export const getUserDeviceTokenKey = (value: string) => {
  return `udk:${value}`;
};
